import {
  notificationTypes,
  type Notification,
  type NotificationType,
} from '@/api/v4/notifications.api';

import { AutoEnhanceNotificationCard } from './auto-enhance-notification-card';
import { CommentTagNotificationCard } from './comment-tag-notification-card';
import { MeetingAttendeeNotificationCard } from './meeting-attendee-notification-card';
import { MeetingCreatedNotificationCard } from './meeting-created-notification-card';
import { MeetingTagNotificationCard } from './meeting-tag-notification-card';
import { NewProjectRequestNotificationCard } from './new-project-request-notification-card';

export const NotificationCard = ({
  notification,
}: {
  notification: Notification;
}) => {
  if (!notificationTypes.includes(notification.type)) {
    return null;
  }

  const cardConfig: Record<NotificationType, React.ReactNode> = {
    autoEnhance: (
      <AutoEnhanceNotificationCard
        key={notification.id}
        notification={notification}
      />
    ),
    commentTag: (
      <CommentTagNotificationCard
        key={notification.id}
        notification={notification}
      />
    ),
    meetingAttendee: (
      <MeetingAttendeeNotificationCard
        key={notification.id}
        notification={notification}
      />
    ),
    meetingCreated: (
      <MeetingCreatedNotificationCard
        key={notification.id}
        notification={notification}
      />
    ),
    meetingTag: (
      <MeetingTagNotificationCard
        key={notification.id}
        notification={notification}
      />
    ),
    newProjectRequest: (
      <NewProjectRequestNotificationCard
        key={notification.id}
        notification={notification}
      />
    ),
  };

  return cardConfig[notification.type];
};
